import { ThemeProvider } from '@material-ui/styles';
/**
 * @ignore - do not document.
 */

export default ThemeProvider;